import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { RoundedButton } from '@/components/buttons';
import { useMainContractDocument } from '@/shared/hooks/useMainContractDocument';

import { useSpecificationStoreActions } from '../../../../../lib';
import { CalculationErrorReportDialog } from '../CalculationErrorReportDialog';
import { MainContractSigningConfirmationDialog } from '../MainContractSigningConfirmationDialog';
import { ReceivePaymentDialog } from '../ReceivePaymentDialog';

export const ReceivePaymentButton = () => {
  const { isSigned } = useMainContractDocument();
  const { openBonusConfirmationDialog, openMainContractConfirmationDialog } = useSpecificationStoreActions();
  const { t } = useTranslation('specifications-detail-page');

  const openDialog = isSigned ? openBonusConfirmationDialog : openMainContractConfirmationDialog;

  return (
    <Fragment>
      <RoundedButton variant="contained" onClick={openDialog}>
        {t('action-bar.actions.receive-payment-button')}
      </RoundedButton>

      <ReceivePaymentDialog />
      <MainContractSigningConfirmationDialog />
    </Fragment>
  );
};

export const CalculationErrorReportButton = () => {
  const { openCalculationErrorReportDialog } = useSpecificationStoreActions();
  const { t } = useTranslation('specifications-detail-page');

  return (
    <Fragment>
      <RoundedButton variant="outlined" onClick={openCalculationErrorReportDialog}>
        {t('action-bar.actions.calculation-error-button')}
      </RoundedButton>

      <CalculationErrorReportDialog />
    </Fragment>
  );
};
